import { useForm } from "react-hook-form";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { EmptyFilter, IUserFilter } from "./Table";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { IRoleMast } from "../../models/RoleMast";

interface IProps {
    filters: IUserFilter,
    setFilters: (filters: IUserFilter) => void,
    loading: boolean,
    // setLoading: (is: boolean) => void
}

const schema = yup.object({
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    status: yup.bool().nullable(),
    temp_Status: yup.bool().nullable(),
    work_From: yup.string().nullable(),
    user_Type:yup.number().nullable(),
    //department: yup.number().nullable(),
});

export const Filter = (props: IProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [roles, setRoles] = useState<Array<IRoleMast>>();
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IUserFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const Status = [
        { label: "--Select--", status: null },
        { label: "Active", status: false },
        { label: "Inactive", status: true }
    ];
    const User_Type = [
        { name: "--Select--", value: 0 },
        // { name: "Internal User", value: 1 },
        { name: "Employer", value: 2 },
        { name: "Sub Vendor", value: 3 },
     
    ]

    const WorkFrom = [
        { from: "--Select--", value: "" },
        { from: "Onsite", value: "Onsite" },
        { from: "Remote", value: "Remote" }
    ];

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    // const loadRoles = async () => {
    //     const response = await Fetch("Dropdown/roles", "GET", null, null, null);
    //     if (response) {
    //         const data: Array<IRoleMast> = await response.json();
    //         const emptyData = {
    //             role_ID: 0,
    //             role_Name: "-- SELECT --",
    //             role_Description: "",
    //             user_Added_by: 0,
    //         };
    //         data.unshift(emptyData);
    //         setRoles(data);
    //     }
    // }

    useEffect(() => {
        loadCompanies();
        loadBranches();
        //loadRoles();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadBranches(value.company);
                } else {
                    loadBranches();
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const onSubmit = (data: IUserFilter) => {
        props.setFilters(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            {/* <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" /> */}
            {/* <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" /> */}
            <JVDropdown column={6} control={control} label="Status" name="status" options={Status} optionLabel="label" optionValue="status" placeholder="Select Status" />
            <JVDropdown column={6} control={control} label="Temp Status" name="temp_Status" options={Status} optionLabel="label" optionValue="status" placeholder="Select Temp Status" />
            <JVDropdown column={6} control={control} label="Work From" name="work_From" options={WorkFrom} optionLabel="from" optionValue="value" placeholder="Select Work From" />
            <JVDropdown column={6} label="User Type" control={control} name="user_Type"  options={User_Type} optionLabel="name" optionValue="value" placeholder="--Select User Type--" />

            {/* <JVDropdown column={6} control={control} label="Department" name="department" options={roles} optionLabel="role_Name" optionValue="role_ID" placeholder="Select Department" /> */}

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading}></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => reset(EmptyFilter)} type="button"></Button>
            </div>
        </form>
    );
}